/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_LEAVE(state, item) {
        state.employeeFiledLeaves.unshift(item)
        //console.log('ADD_LEAVE')
        //console.log(state.employeeFiledLeaves)
    },
    UPDATE_LEAVE(state, item) {
        
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === item.employeeFiledLeaveId)
        Object.assign(state.employeeFiledLeaves[index], {
            leaveTypeId:item.leaveTypeId,
            fromDate:item.fromDate,
            toDate:item.toDate,
            isMorningFrom:item.isMorningFrom,
            isMorningTo:item.isMorningTo,
            noOfDays:item.noOfDays,
            hours:item.hours,
            minutes:item.minutes,
            reason:item.reason,
            isDraft:item.isDraft,
            isSubmitted:item.isSubmitted,
            submittedOn:item.submittedOn,
            isCancelled:item.isCancelled,
            cancelledOn:item.cancelledOn,
            fileId:item.fileId,
            approversLMs: item.approversLMs
        })
        
    },
    REMOVE_LEAVE(state, leaveId) {
        const leaveIndex = state.employeeFiledLeaves.findIndex((e) => e.id == leaveId);
        state.employeeFiledLeaves.splice(leaveIndex, 1);
    },
    GET_ALL_LEAVE(state, payload) {
        state.employeeFiledLeaves = payload
        // //console.log(state.employeeFiledLeaves)
    },
    
    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_APPROVERS(state, approvers){
        state.approvers = JSON.parse(JSON.stringify(approvers))
        // console.log('APPROVERS')
        // console.log(state.approvers)

       
    },
    UNSUBMIT_LEAVE(state, leaveId){
        //console.log('okay')
        //console.log(leaveId)
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === leaveId)
        Object.assign(state.employeeFiledLeaves[index], {isDraft: true, isSubmitted: false})
        
        
    },
    CANCELLED_LEAVE(state, items){
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
        Object.assign(state.employeeFiledLeaves[index], {isDraft: items.isDraft, 
            isSubmitted: items.isSubmitted, 
            isCancelled: items.isCancelled, 
            remarks: items.remarks})
        state.employeeFiledLeaves[index].approversLMs.forEach((x) => {
            x.isRevised = items.isRevised
        })
        // const index =  state.employeeFiledLeaves[index].approvers.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
    },
    RETRACKED_LEAVE(state, items){
        console.log(items)
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
        Object.assign(state.employeeFiledLeaves[index], {isDraft: items.isDraft,
            isRetracted : items.isRetracted,
            retractedOn : items.retractedOn, 
            remarks: items.remarks})

        const app = state.employeeFiledLeaves[index].approversLMs.filter((a) => a.employeeFiledLeaveId === items.employeeFiledLeaveId)
        console.log(app)
        app.forEach(idx => {
            console.log(idx)
            Object.assign(idx, {
                isApproved : false 
            })
        })
        
        // const a = state.employeeFiledLeaves[index].approversLMs.findIndex((a) => a.approverId === items.approverId)
        // Object.assign(state.employeeFiledLeaves[index].approversLMs[a], {
        //     isApproved : items.isApproved
        // })
    },
    APPROVED_LEAVE(state, items){
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
        // Object.assign(state.employeeFiledLeaves[index], {isDraft: items.isDraft, remarks: items.remarks})

        const a = state.employeeFiledLeaves[index].approversLMs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledLeaves[index].approversLMs[a], {
            isUnread : items.isUnread, 
            isApproved: items.isApproved, 
            approvedOn : items.approvedOn, 
            isRetracted : items.isRetracted
        })
    },
    DENIED_LEAVE(state, items){
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
        // Object.assign(state.employeeFiledLeaves[index], {isDraft: items.isDraft, remarks: items.remarks})

        const a = state.employeeFiledLeaves[index].approversLMs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledLeaves[index].approversLMs[a], {
            isUnread : items.isUnread, 
            isDenied: items.isDenied, 
            deniedOn : items.deniedOn, 
            isRetracted : items.isRetracted, 
            comments: items.comments
        })
    },
    REVISED_LEAVE(state, items){
        const index = state.employeeFiledLeaves.findIndex((e) => e.employeeFiledLeaveId === items.employeeFiledLeaveId)
        // Object.assign(state.employeeFiledLeaves[index], {isDraft: items.isDraft, remarks: items.remarks})

        const a = state.employeeFiledLeaves[index].approversLMs.findIndex((a) => a.approverId === items.approverId)
        Object.assign(state.employeeFiledLeaves[index].approversLMs[a], {
            isUnread : items.isUnread, 
            isRevised: items.isRevised, 
            forRevisionOn : items.forRevisionOn, 
            isRetracted : items.isRetracted, 
            comments: items.comments
        })
    },
        


}